import { SelectEntry as SE } from '@bpmn-io/properties-panel';
import type { FunctionalComponent, VNode } from '@bpmn-io/properties-panel/preact';
import type { ElementLike } from 'diagram-js/lib/model/Types';
// import type { Element } from 'bpmn-js/lib/model/Types';

export type Option = Partial<Pick<HTMLOptionElement, 'disabled'>> &
    Pick<HTMLOptionElement, 'label' | 'value'>;

export const SelectEntry = SE as <E extends ElementLike = ElementLike>(props: {
    description?: string;
    disabled?: boolean;
    element: E;
    // getOptions: (element: E) => { label: string; value: string }[];
    getOptions: (element: E) => Option[];
    getValue: (element: E) => string;
    id: string;
    label?: string;
    onBlur?: (event: FocusEvent) => void;
    onFocus?: (event: FocusEvent) => void;
    setValue: (value: string, validationError?: unknown) => void;
    tooltip?: string | FunctionalComponent;
    validate?: (value: string) => string | undefined | void;
}) => VNode;

export const createOption = (
    label: Option['label'],
    value: Option['value'],
    disabled?: Option['disabled']
): Option => {
    const option: Option = { label, value };
    if (disabled) {
        option.disabled = disabled;
    }
    return option;
};

export const getOptionLabel = (options: Option[], value: Option['value']): string | undefined =>
    options.find((option) => option.value === value)?.label;

export const getOption = (options: Option[], value: Option['value']): Option | undefined =>
    options.find((option) => option.value === value);
